import { cn } from '@/components/ui/cn';
import { Text, type TextProps } from '@/components/ui/Text';

/** Uppercase tracked "field-manual" eyebrow. Callers pass size, tracking, color. */
export const Eyebrow = (p: TextProps) => (
  <Text variant="none" {...p} className={cn('font-accent uppercase', p.className)} />
);
